import Head from 'next/head';
import { getImageProps } from 'next/image';

type Props = {
  desktopSrc?: string | null;
  mobileSrc?: string | null;
  alt?: string;
  sizes?: string;
  className?: string;
  priority?: boolean;
  quality?: number;
  width?: number;
  height?: number;
};

// Khớp breakpoint md của Tailwind (48.125rem = 770px)
const MOBILE_MEDIA = '(max-width: 769px)';
const DESKTOP_MEDIA = '(min-width: 770px)';

const isValidSrc = (src?: string | null): src is string =>
  !!src && !src.includes('undefined');

const ArtDirectedImage = ({
  desktopSrc,
  mobileSrc,
  alt,
  sizes = '100vw',
  className,
  priority = false,
  quality = 80,
  width = 1,
  height = 1,
}: Props) => {
  const desktop = isValidSrc(desktopSrc) ? desktopSrc : mobileSrc;
  const mobile = isValidSrc(mobileSrc) ? mobileSrc : desktopSrc;
  if (!isValidSrc(desktop) || !isValidSrc(mobile)) return null;

  const common = {
    alt: alt || 'Sun Paradise Land',
    sizes,
    quality,
    width,
    height,
  };
  const {
    props: { srcSet: desktopSrcSet },
  } = getImageProps({ ...common, src: desktop });
  const {
    props: { srcSet: mobileSrcSet, ...imgProps },
  } = getImageProps({ ...common, src: mobile });
  // React 18.2 chỉ nhận thuộc tính dạng chữ thường
  const highPriority = priority ? { fetchpriority: 'high' } : {};

  return (
    <>
      {priority && (
        <Head>
          <link
            rel="preload"
            as="image"
            key={`preload-desktop-${desktop}`}
            imageSrcSet={desktopSrcSet}
            imageSizes={sizes}
            media={DESKTOP_MEDIA}
            {...highPriority}
          />
          <link
            rel="preload"
            as="image"
            key={`preload-mobile-${mobile}`}
            imageSrcSet={mobileSrcSet}
            imageSizes={sizes}
            media={MOBILE_MEDIA}
            {...highPriority}
          />
        </Head>
      )}
      <picture className="contents">
        <source media={DESKTOP_MEDIA} srcSet={desktopSrcSet} sizes={sizes} />
        <source media={MOBILE_MEDIA} srcSet={mobileSrcSet} sizes={sizes} />
        <img
          {...imgProps}
          srcSet={mobileSrcSet}
          loading={priority ? 'eager' : 'lazy'}
          {...highPriority}
          style={{ ...imgProps.style, height: '100%' }}
          className={className}
        />
      </picture>
    </>
  );
};

export default ArtDirectedImage;
